import { render } from "./VersionControl.vue?vue&type=template&id=13d62ca7"
import script from "./VersionControl.vue?vue&type=script&lang=js"
export * from "./VersionControl.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__